<!--酒店报价-->
<template>
  <div>
        <!--报价弹窗-->
        <el-dialog 
        :visible.sync="quotationShow" 
        width="800px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :z-index="5"
        center 
        >
            <!-- <div class="order-hotel-fill-title">房间报价</div> -->
            <div class="breakfast mb-3">
                <div class="room-title mt-2">
                    报价酒店
                </div>
                <el-select v-model="formData.store_id" placeholder="请选择" class="select" @change="betterOfferHotel(formData.store_id)">
                    <el-option
                    v-for="item in match_hotel_list"
                    :key="item.offer_store_id"
                    :label="item.hotel_title"
                    :value="item.offer_store_id"
                    >
                        <span style="float: left">{{ item.hotel_title }}</span>
                        <span :class="item.whetherQuote?'text-success':'text-danger'" style="float: right;  font-size: 12px">{{ item.whetherQuote?'已报价':'未报价' }}</span>
                    </el-option>
                </el-select>
            </div>
            <div class="breakfast mb-3 breakfast-type" v-if="orderDetail.order_type==1">
                    <!--早餐类型-->
                    <div class="room-title">
                        早餐提供
                    </div>
                    <!--单选早餐-->
                    <div class="breakfast-value" >
                        <!--房间类型-->
                        <el-select 
                            v-model="formData.breakfast_type"
                            @change="changeBreakfastType($event)"
                            @blur="blurBreakfastType($event)"
                            filterable
                            allow-create
                            default-first-option
                            placeholder="请选择或输入早餐提供"
                            class="w-100">
                            <el-option
                                v-for="roomItem in $GVAR.breakfastTypeArr"
                                :key="roomItem.name"
                                :label="roomItem.name"
                                :value="`${roomItem.id},${roomItem.name}`"
                            >
                            </el-option>
                        </el-select>
                        <!-- <el-radio-group v-model="formData.breakfast_type" size="small">
                            <el-radio-button v-for="item in $GVAR.breakfastTypeArr" :key="item.id" :label="item.id">{{item.name}}</el-radio-button>
                        </el-radio-group> -->
                    </div>
            </div>
            <!--房间报价-->
            <roomType 
                class="mb-3" 
                :room_need_clone="formData.room_offer.list" 
                @selectAllshwo="selectAll=true" 
                v-if="formData.room_offer.list"
                ref="roomType"
                >
            </roomType> 
            <!--会议类型-->
            <meetingType 
                :meeting_need="formData.meeting_offer.list" 
                v-if="formData.meeting_offer.list"
                ref="meetingType"
                >
            </meetingType> 
            <!--报价说明-->
            <div class="breakfast mt-3 breakfast-type">
                <div class="room-title">
                    报价说明
                </div>
                <el-input
                    type="textarea"
                    :rows="4"
                    placeholder="(非必填)可填写备注信息"
                    resize="none"
                    class="w-85"
                    v-model="formData.offer_remark">
                </el-input>
            </div>
            <!--提示-->
            <span class="breakfast-hint">*说明：酒店可以选择自己合适的房型进行报价，也可以自定义房型名称进行报价,价格是按指定房型的单个房间的单晚价格进行填写</span>
            <div class="breakfast-bottom-btn">
                <el-button   size="small" @click="$emit('onShow')">考虑一下</el-button>
                <el-button  @click="submitForm" type="primary" size="small">确认报价</el-button>
            </div>
        </el-dialog>
        <!--全选报价-->
        <el-dialog 
        :visible.sync="selectAll" 
        width="400px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :z-index="9"
        center 
        top="32vh"
        >
            <div class="room-title mb-3">
                一键报价
            </div>
            <div class="customize">
                <!--房间类型-->
                <el-select 
                    v-model="selectAllFrom.offer_title"
                    @change="getId($event,2)"
                    @blur="blurs($event,2)"
                    filterable
                    allow-create
                    default-first-option
                    placeholder="请选择或输入房型"
                    :class="{ roomRed: selectAllFrom.offer_title==''&&isSubmit }"
                    class="w-70">
                    <el-option
                        v-for="roomItem in StoreRoomList"
                        :key="roomItem.title"
                        :label="roomItem.title"
                        :value="`${roomItem.id},${roomItem.title}`"
                    >
                    </el-option>
                </el-select>
                <!--单价-->
                <el-input 
                placeholder="金额"
                v-model.number="selectAllFrom.offer_price"  
                class=" ml-2 w-35"
                :class="{ roomRed: selectAllFrom.offer_price==''&&isSubmit }"
                type="number" >
                    <!-- <span slot="prepend">&yen;</span> -->
                    <span slot="append" class="lisxn">元/晚</span>
                </el-input>
            </div>
            <!--提示-->
            <span class="breakfast-hint">说明：一键报价会覆盖已报价信息</span>    
            <div class="breakfast-bottom-btn">
                <el-button  size="small" @click="selectAll=false">返回</el-button>
                <el-button  type="primary" size="small" @click="submitPost()">确认填写</el-button>
            </div>
        </el-dialog>
  </div>
</template>

<script>
import { mapState,mapActions} from 'vuex'
import roomType from './Comp/roomType'
import meetingType from './Comp/meetingType'
export default {
  name: 'OrderHotelFill',
  components: {
    meetingType,
    roomType,
  },
  props: {
    orderDetail: {
      type: Object,
      default: () => {},
    },
    quotationShow: {
      type: Boolean,
      default: false,
    },
    match_hotel_list: {
      type: Array,
      default: [],
    },
  },
  data() {      
    return {
        formData: {
            store_id:'',                      //报价酒店ID
            oid:'',                           //订单ID
            breakfast_type:'',                //早餐类型
            breakfast_typeArr:{},              //自定义早餐类型
            offer_remark:'',                  //报价说明
            room_offer:[],                    //房间报价
            meeting_offer:[],                 //会议室报价
        },
        selectAll:false,                       //全选报价开关
        selectAllFrom:{                       //全选报价信息
            offer_title:'',
            offer_price:'',
        },
        isSubmit: false,                      //全选是否填写内容
    };
  },
  computed: {
     ...mapState(['StoreRoomList']),
  },
  watch: {
  },
  created() {},
  mounted() {
  },
  methods: {
    ...mapActions(['POST_HotelsMeetingList','POST_HotelsRoomList','HotelOfferPrice','HotelOfferPrice']),
    //确认全选报价
    submitPost(){
        //判断是否填写内容
        if(this.selectAllFrom.offer_title==''||this.selectAllFrom.offer_price==''){
            this.isSubmit=true;
            return;
        };
        //提交全选报价
        this.formData.room_offer.list.forEach(item => {
            item.offer_info = item.offer_info.map(roomItem => ({...roomItem, ...this.selectAllFrom}))
        });
        this.selectAll=false;
    },
    //切换报价酒店
    betterOfferHotel(id){
        let offer_store_id=Number(id); 
        //获取酒店报价时会议室列表信息
        this.POST_HotelsMeetingList({hotel_id:offer_store_id})
        //获取修改时房间列表信息
        this.POST_HotelsRoomList({hotel_id:offer_store_id})
        let match_hotel_list=this.match_hotel_list;
        let match_hotel=match_hotel_list.find(item=>item.offer_store_id==offer_store_id); //或者选中的酒店报价组
        //判断如果是接不了酒店重新赋值
        let value=this.$_Object.mergeByFirstKey(this.formData,match_hotel);               //俩个对象合并只合并第一个存在的key
        value={
            ...value,
            room_offer:match_hotel.offer_type==1?match_hotel.room_offer_arr || []:this.orderDetail.room_need_arr || [],
            meeting_offer:match_hotel.offer_type==1?match_hotel.meeting_offer_arr || []:this.orderDetail.meeting_need_arr|| [],
            offer_remark:match_hotel.offer_type==1?value.offer_remark:'',
        }
        console.log(value);
        this.formData=value;
    },
    //提交报价
    submitForm(){
        let formData=JSON.parse(JSON.stringify(this.formData));
        //验证早餐类型
        if(formData.breakfast_type==''&&this.orderDetail.order_type==1){ this.$message.error('请填写或选择早餐提供类型');return};
        //验证房间报价信息是否填写完整
        let roomType=formData.room_offer.list?this.$refs.roomType.submitForm():true;  
        if(!roomType)return;
        //验证会议室报价信息是否填写完整
        let meetingType=formData.meeting_offer.list?this.$refs.meetingType.submitForm():true;  
        //早餐类型加入报价表单下
        console.log(roomType);
        //通过提交报价
        if(roomType&&meetingType){
            this.$emit('onShow');
            //房间报价默认早餐类型
            if(roomType.length>0){
                roomType.forEach(item => {
                    item.offer_info.forEach(roomItem => {
                        roomItem.breakfast = this.formData.breakfast_type
                    })
                });
            }
            [
            ['room_offer', 'room_offer'],
            ['meeting_offer', 'meeting_offer']
            ].forEach(([src, tar]) => {
            const arr = formData[src].list
            if (Array.isArray(arr) && arr.length > 0) {
                formData[tar] = JSON.stringify({
                    ...formData[src],
                    list:tar=='room_offer'?roomType:meetingType
                })
            }
            });
            formData.deposit='';
            //提交报价信息
            this.HotelOfferPrice({
                data:formData,
                successFun:()=>{
                    this.$emit('getorderDetail');
                    this.$message.success('报价成功');
                }
            })
        }
    },
    // 一键报价房型相关
    getId(val,i){
        let [id, name] = val.split(',');
        let room_offer={...this.selectAllFrom,offer_id:id?id:'0',offer_title:name?name:id};
        i==1?this.breakfast_typeArr=room_offer:this.selectAllFrom=room_offer;
    },
    blurs(val,i){
        if(val.target.value){
            let room_offer={...this.selectAllFrom,offer_id:'0',offer_title:val.target.value}
            i==1?this.breakfast_typeArr=room_offer:this.selectAllFrom=room_offer;
        }
        console.log(this.room_need,78910);
    },
    //早餐类型
    changeBreakfastType(val){
        let [id, name] = val.split(',');
        this.formData.breakfast_type=name;
    },
    blurBreakfastType(val){
        if(val.target.value){
            this.formData.breakfast_type=val.target.value;
            console.log(this.selectAllFrom);
        }
    }
  }
};
</script>

<style lang="scss" scoped>
    .order-hotel-fill-title{
        font-size: 20px;
        font-weight: bold;
        color: #333;
        text-align: center;
        margin-bottom: 20px;
    }
    .breakfast{
        display: flex;
        justify-content: space-between;
        border-bottom: 1px #eee solid;
        padding-bottom: 16px;
    }
    .room-title{
        font-size: 16px;
        font-weight: bold;
        color: #333;
        position: relative;
        padding-left: 12px;
        &::after{
            content: '';
            position: absolute;
            left: 0;
            top: 2px;
            height: 20px;
            width: 4px;
            background-color: var(--smtc-color-primary);
            border-radius: 50px;
        }
    }
    .breakfast-bottom-btn{
        margin-top: 20px;
        display: flex;
        justify-content: center;
    }
    .breakfast-hint{
        font-size: 12px;
        width: 100%;
        color: red;
        display: block;
        margin-top: 12px;
    }
    .breakfast-value{
        display: flex;
        flex-direction: column;
        width:  636px;
    }
    .customize{
        display:flex;
        justify-content: flex-end;
    }
</style>
<style>
    .breakfast  .el-input__inner{
        font-size: 12px;

    }
    .breakfast-type .el-input__inner{
        line-height: 31px;
        height: 31px;
    }
    .breakfast-type .el-input__icon{
        line-height: 31px;
    }
    .breakfast .select .el-input__inner{
        min-width: 636px;
    }
</style>